import type { IInteractiveExamPublishDto } from "./types";
import type { IPathBaseParam } from "./path";

import type { IApiResponse } from "@/api";
import { createPostApi } from "@api/util/createPostApi";

const postApis = createPostApi<
  IApiResponse<unknown>,
  IPathBaseParam,
  IInteractiveExamPublishDto
>("courses.exams.interactive.publish");

export const publish = {
  ...postApis,
};
